module.exports = __webpack_public_path__ + "media/assets/images/cloudy_sometime_will_sunny-3ad632cee30a5561af0f43d9ce4cc242.png";